import * as React from "react";
export function SvgDataCatalogLineageDsActive(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M6 17c0 1.7 2.5 3 5.5 3s5.5-1.3 5.5-3V8c0-1.7-2.5-3-5.5-3S6 6.3 6 8v9zm1-7.3c1 .8 2.6 1.3 4.5 1.3s3.5-.5 4.5-1.3V17c0 1.1-2 2-4.5 2S7 18.1 7 17V9.7zm4.5.3C9 10 7 9.1 7 8s2-2 4.5-2 4.5.9 4.5 2-2 2-4.5 2z"
        fill="#333"
      />
    </svg>
  );
}
